import Dialog from '@mui/material/Dialog'
import { palettePrimaryMain } from '@/theme/designTokens'

import DialogContent from '@mui/material/DialogContent'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { WizardAiGoalAnalysisIcon } from './CampaignWizardStepIcons'

/** Figma `4255:3797` — Generating modal (Dev Handoff). */
export function CampaignGeneratingDialog({
  open,
  subtitle,
  dataTestId = 'campaign-generating-dialog',
}: Readonly<{ open: boolean; subtitle: string; dataTestId?: string }>) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      slotProps={{
        backdrop: { sx: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } },
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          m: 0,
          width: 448,
          maxWidth: 'calc(100% - 32px)',
          borderRadius: '10px',
          boxShadow:
            '0px 20px 25px rgba(0, 0, 0, 0.1), 0px 8px 10px rgba(0, 0, 0, 0.1)',
          overflow: 'hidden',
        },
      }}
      data-testid={dataTestId}
    >
      <Box
        sx={{
          height: 112,
          pt: '32px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: '#F1FAFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <WizardAiGoalAnalysisIcon sx={{ color: palettePrimaryMain, fontSize: 24 }} />
        </Box>
      </Box>
      <DialogContent
        sx={{
          px: 3,
          pt: 0,
          pb: 3,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '12px',
          minHeight: 98,
          boxSizing: 'border-box',
        }}
      >
        <Typography
          fontWeight={700}
          fontSize={20}
          lineHeight="28px"
          color="#23262f"
          letterSpacing="-0.45px"
          component="h2"
        >
          Generating...
        </Typography>
        <Typography
          fontSize={14}
          lineHeight="22.75px"
          color="#4a5565"
          letterSpacing="-0.15px"
          sx={{ maxWidth: 388 }}
        >
          {subtitle}
        </Typography>
      </DialogContent>
    </Dialog>
  )
}
